import { Box } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import { Paragraph, Title } from '@treams/treams-ui';

import Logo from '../../../../src/assets/logo.svg';

export function Jumbo() {
	const { t } = useTranslation();

	return (
		<>
			<Box width={3 / 12}>
				<a href="https://treams.nl">
					<Logo />
				</a>
			</Box>
			<Box mt={4} mb={3}>
				<Title mb={1}>{t('onboarding.jumbo.title')}</Title>
				<Paragraph>
					<big>{t('onboarding.jumbo.description')}</big>
				</Paragraph>
			</Box>
		</>
	);
}
